var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "px-16px tablet:px-36px mb-36px flex flex-col tablet:flex-row tablet:gap-24px" };
var _hoisted_2 = { class: "thumb mx-auto" };
var _hoisted_3 = ["src", "alt"];
var _hoisted_4 = { class: "mt-8 tablet:mt-0" };
var _hoisted_5 = { class: "text-14px text-center tablet:text-left font-bold" };
var _hoisted_6 = { class: "mt-8 text-12px tablet:text-16px" };
import { ref, computed, onMounted, reactive } from 'vue';
import api from '../../modules/axios';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TeamProfile',
    props: {
        teamId: { type: String, required: true },
        logo: { type: String, required: false },
        description: { type: String, required: false },
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var isLoading = ref(false);
        var teamProfile = reactive({
            name: '',
            logo: '',
            description: '',
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isLoading.value = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.get("/communities/".concat(props.teamId, "/profile"))];
                    case 2:
                        result = _a.sent();
                        if (result.data.name) {
                            teamProfile.name = result.data.name;
                            teamProfile.logo = (props.logo) || result.data.logo;
                            teamProfile.description = (props.description) || result.data.description;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [2 /*return*/, err_1];
                    case 4:
                        isLoading.value = false;
                        return [2 /*return*/];
                }
            });
        }); });
        var teamName = computed(function () {
            return teamProfile.name;
        });
        var teamLogo = computed(function () {
            return teamProfile.logo;
        });
        var teamDescrption = computed(function () {
            var stripTags = function (text) { return text.replace(/<[^>]*>|&[^;]+;/g, ''); };
            return stripTags(teamProfile.description);
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                        src: teamLogo.value,
                        alt: teamName.value,
                        class: "mb-6"
                    }, null, 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(teamName.value), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(teamDescrption.value), 1)
                ])
            ]));
        };
    }
});
